import axios, { AxiosResponse } from "axios"
import { header } from "./newsletter-api"

interface healthInsurance {
  familyName: string
  givenName: string
  email: string
  phoneNumber: string
  healthInsurance: string
  diagnoses: string[]
  interestConfirmed: boolean
  dataMayBeUsed: boolean
  zipCode: string
}

interface dermatologist {
  familyName: string
  givenName: string
  email: string
  city: string
  zipCode: string
  street: string
  houseNumber: string
  phoneNumber: string
  healthInsurance: string
  diagnoses: string[]
  interestConfirmed: boolean
  dataMayBeUsed: boolean
}

interface requestHelp {
  requestsHelpForFindingDermatologist: boolean
}

export const postHealthInsuranceInterest = async (values: healthInsurance) => {
  const url = "/api/insurance-interest"

  return axios.post(url, values, {
    timeout: 15000,
    timeoutErrorMessage: "Timeout",
    headers: header,
  })
}
export const postDermatologistInterest = async (values: dermatologist) => {
  const url = "/api/dermatologist-interest" // Call your own Next.js API route
  const clientRequestId =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`

  console.log(values)
  return axios.post<dermatologist, AxiosResponse<{ uuid: string }>>(url, values, {
    timeout: 15000,
    timeoutErrorMessage: "Timeout",
    headers: {
      ...header,
      "x-client-request-id": clientRequestId,
      "x-client-started-at": String(Date.now()),
    },
  })
}
export const addDermatologistClick = async (uuid: string, values: string[]) => {
  const url = `/api/finder/dermatologist/${uuid}` // Call your own Next.js API route
  return axios.post<string[], AxiosResponse<{ uuid: string }>>(url, values, {
    timeout: 15000,
    timeoutErrorMessage: "Timeout",
    headers: header,
  })
}
export const updateDermatologistInterest = async (uuid: string, values: requestHelp) => {
  const url = `/api/requests-help/${uuid}` // Call your own Next.js API route
  console.log(url)
  return axios.put(url, values, {
    timeout: 15000,
    timeoutErrorMessage: "Timeout",
    headers: header,
  })
}
